<template>
  <span v-if="step.textoAyuda">
    <div v-if="showToggle">
      <p v-if="!mostrado" class="toggle toggle-mas">
        <a class="ver-ayuda" @click.prevent="mostrado = !mostrado" href="#"
          >Ver ayuda</a
        >
      </p>

      <p v-else class="toggle toggle-menos">
        <a class="ver-ayuda" @click.prevent="mostrado = !mostrado" href="#"
          >Ocultar ayuda</a
        >
      </p>
    </div>

    <div v-if="step.textoAyuda && mostrado" class="help-wrapper">
      <div class="help-cont">
        <div class="wysiwyg">
          <p>
            <strong>{{ step.textoAyudaTitulo }}</strong>
          </p>
          <p>{{ step.textoAyuda }}</p>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
export default {
  store: ["step"],
  data() {
    return {
      mostrado: true,
      showToggle: false
    };
  },
  mounted: function() {
    let isMobile = window.screen.width < 1023;
    if (isMobile) {
      this.showToggle = true;
      this.mostrado = false;
    }
  }
};
</script>

<style scoped>
.toggle {
  padding: 0.7rem;
}

.toggle-mas:before {
  display: inline-block;
  vertical-align: top;
  content: "";
  margin-right: 1em;
  width: 2em;
  height: 2em;
  background: url(../assets/sprite_icons.png) no-repeat -160px -40px;
  font-size: 1rem;
}

.toggle-menos:before {
  display: inline-block;
  vertical-align: top;
  content: "";
  margin-right: 1em;
  width: 2em;
  height: 2em;
  background: url(../assets/sprite_icons.png) no-repeat -136px -40px;
  font-size: 1rem;
}

.ver-ayuda {
  font-size: 1.8rem;
}
</style>
